import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { queryAvailableLocales, QUERY_KEY, AvailableLocalesQueryKey } from 'src/queries/queryAvailableLocales';

export const useQueryAvailableLocales = (
    accessToken: string | undefined | false,
    search: {
        productKey: string;
        productVersion: number;
    },
    options?: UseQueryOptions<string[], Error, string[], AvailableLocalesQueryKey>,
): UseQueryResult<string[], Error> => useQuery<string[], Error, string[], AvailableLocalesQueryKey>(
    [QUERY_KEY, accessToken, search],
    queryAvailableLocales,
    {
        suspense: false,
        ...options,
    },
);
